export default "__VITE_ASSET__74bf5695__"